/* eslint-disable max-len */
import { SvgIcon } from '@mui/material';
import { CustomSvgIcon } from '@tassat/ui-definitions';
import * as React from 'react';

export default function AddressBook(props: CustomSvgIcon) {
    const {
        id,
        className,
        iconColor,
        onClick
    } = props;

    return (
        <SvgIcon
            className={className || ''}
            id={id || ''}
            onClick={onClick}
        >
            <svg
                viewBox='0 0 27.31 27.58'
                xmlns='http://www.w3.org/2000/svg'
            >
                <title>AddressBook_1</title>
                <g
                    data-name='Layer 2'
                    fill={iconColor || '#000'}
                    id='Layer_2'
                >
                    <g
                        data-name='Layer 1'
                        id='Layer_1-2'
                    >
                        <path d='M4.5,8H.5A.51.51,0,0,1,0,7.49.5.5,0,0,1,.5,7h4a.5.5,0,0,1,.51.5A.51.51,0,0,1,4.5,8Z' />
                        <path d='M4.5,20.3H.5a.51.51,0,0,1-.5-.51.5.5,0,0,1,.5-.5h4a.5.5,0,0,1,.51.5A.51.51,0,0,1,4.5,20.3Z' />
                        <path
                            d='M22.69,27.58H4.87a1.51,1.51,0,0,1-1.53-1.5V22.13h1v3.95a.52.52,0,0,0,.53.5H22.69a3.57,3.57,0,0,0,3.62-3.5V4.5A3.57,3.57,0,0,0,22.69,1H4.87a.51.51,0,0,0-.53.49v4h-1v-4A1.51,1.51,0,0,1,4.87,0H22.69a4.57,4.57,0,0,1,4.62,4.5V23.08A4.57,4.57,0,0,1,22.69,27.58Z'
                        />
                        <rect
                            height='5.63'
                            width='1.01'
                            x='3.34'
                            y='11'
                        />
                        <path
                            d='M21.08,17.06a7.1,7.1,0,0,0-3.33-2.56,4.79,4.79,0,0,0,2.14-3.13,4.86,4.86,0,0,0-.95-4,4.59,4.59,0,0,0-7.24,0,4.86,4.86,0,0,0-.95,4,4.79,4.79,0,0,0,2.14,3.13,7.14,7.14,0,0,0-3.32,2.56,7.41,7.41,0,0,0-1.39,4.35.56.56,0,1,0,1.12,0,6.26,6.26,0,0,1,3-5.37,5.9,5.9,0,0,1,6,0,6.25,6.25,0,0,1,3,5.37.56.56,0,1,0,1.11,0A7.4,7.4,0,0,0,21.08,17.06Zm-2.21-6.65a3.69,3.69,0,0,1-1,2.58,3.53,3.53,0,0,1-2.51,1.07A3.47,3.47,0,0,1,12.81,13a3.73,3.73,0,0,1,0-5.17,3.47,3.47,0,0,1,2.51-1.07,3.53,3.53,0,0,1,2.51,1.07A3.69,3.69,0,0,1,18.87,10.41Z'
                        />
                    </g>
                </g>
            </svg>
        </SvgIcon>
    );
}